export default __webpack_public_path__ + "static/media/stapler.0ca0b0b6.png";